import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
    .team-member-area {
        background: ${colors.bg2};
        padding: 50px 0;

        .sec-title {
            h4 {
                color: ${colors.black1};
                line-height: 35px;
                font-weight: 600;
                max-width: 550px;
                margin: auto;
                margin-bottom: 50px;
                text-align: center;

                @media(max-width: 767px) {
                    font-size: 20px;
                    margin-bottom: 15px;
                }
            }
        }

        .team-slider {
            position: relative;

            .team-item {
                position: relative;
                margin-bottom: 55px;

                img {
                    border-radius: 5px;
                    width: 100%;
                    height: auto;
                }

                .img-content {
                    background: #ffffff;
                    box-shadow: 0 10px 18px rgba(0, 0, 0, 0.07);
                    position: absolute;
                    bottom: -30px;
                    left: 10%;
                    width: 80%;
                    z-index: 1;
                    border-radius: 5px;
                    padding: 20px 10px;
                    box-sizing: border-box;

                    h5 {
                        color: ${colors.black1};
                        font-weight: 600;
                        margin-bottom: 10px;
                        height: auto;
                        min-height: 60px;
                        line-height: 1.4;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        word-wrap: break-word;
                        
                        @media(max-width: 767px) {
                            height: auto;
                            overflow-y: auto;
                            margin-bottom: 0;
                            text-align: left;
                        }
                        @media (max-width: 991px) {
                            height: auto;
                            font-size: 16px;
                            margin-bottom: 0;
                            -webkit-letter-spacing: 0;
                            -moz-letter-spacing: 0;
                            -ms-letter-spacing: 0;
                            letter-spacing: 0;
                            text-align: left;
                        }
                        
                    }

                    p {
                        font-size: 13px;
                        color: #666666;
                        font-weight: 500;
                        margin-bottom: 20px;
                        height: 285px;
                        line-height: 1.5;
                        overflow-y: auto;
                        text-overflow: ellipsis;
                        text-align: left;
                        word-wrap: break-word;

                        @media(max-width: 767px) {
                            height: 190px;
                            overflow-y: auto;
                            margin-bottom: 0;
                            text-align: left;
                        }
                        @media (max-width: 991px) {
                            height: 190px;
                            font-size: 12px;
                            margin-bottom: 0;
                            -webkit-letter-spacing: 0;
                            -moz-letter-spacing: 0;
                            -ms-letter-spacing: 0;
                            letter-spacing: 0;
                            text-align: left;
                        }
                    }

                    .img-fluid_content_logo {
                        display: block;
                        margin: 20px auto;
                        width: 70px;
                        height: auto;

                        @media(max-width: 767px) {
                            display: none;
                        }
                        @media (max-width: 991px) {
                            display: none;
                        }
                    }
                }
            }

            .custom-modal .modal-backdrop {
                background-color: rgba(0, 0, 0, 0.7); /* black overlay */
            }

            .slider-dot {
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                margin-top: 25px !important;

                .swiper-pagination-bullet {
                    width: 22px;
                    height: 9px;
                    background: ${colors.text4};
                    display: inline-block;
                    margin: 3px;
                    opacity: 1 !important;
                    border-radius: 5px;
                }

                .swiper-pagination-bullet.swiper-pagination-bullet-active {
                    background: ${colors.green};
                }
            }
        }

        @media(max-width: 992px) {
            .team-item .img-content {
                width: 90%;
                left: 5%;
                bottom: -25px;
            }
        }

        @media(max-width: 767px) {
            padding: 35px 0;

            .team-item .img-content {
                position: relative;
                bottom: auto;
                left: auto;
                width: 100%;
                margin-top: 10px;
                padding: 15px;
            }

            .team-item .img-content h5 {
                font-size: 16px;
                height: 105px;
                line-height: 1.4;
            }

            .team-item .img-content p {
                font-size: 12px;
                height: 190px;
                max-height: 190px;
                overflow-y: auto;
            }

            .img-fluid_content_logo {
                display: none;
            }

            .slider-dot {
                margin-top: 20px !important;

                .swiper-pagination-bullet {
                    width: 15px;
                    height: 7px;
                    margin: 2px;
                }
            }
        }

        @media(max-width: 400px) {
            .team-item .img-content p {
                max-height: 150px;
            }
        }
    }
`;